import { IClassroom } from "../../classrooms/types";
import {
    createApiQueryHook,
    IApiQueryFunction,
    IOrderable,
    IPaginateable,
    mapOrder,
    mapPagination,
} from "../../utils/api";
import { mapRelationalFilter, RelationalFilter } from "../../utils/filters";
import { serialize } from "../../utils/url";
import { IScenarioPeriodList } from "../types/IScenarioPeriodList";

export interface IScenarioPeriodListQueryParameters extends IPaginateable, IOrderable<"startDate" | "endDate"> {
    filters: {
        classroom?: RelationalFilter<IClassroom>;
    };
}

export type IScenarioPeriodListQueryResult = IScenarioPeriodList;

const mapFilters = (filters: IScenarioPeriodListQueryParameters["filters"]) => {
    const { classroom } = filters ?? {};

    return { "classroom.uuid": mapRelationalFilter(classroom) };
};

export const scenarioPeriodListQuery: IApiQueryFunction<IScenarioPeriodListQueryParameters> = ({
    filters,
    pagination,
    order,
}) => {
    return {
        method: "GET",
        url: `/scenario_periods${serialize(
            {
                ...mapPagination(pagination),
                ...mapOrder(order),
                ...mapFilters(filters),
            },
            true,
        )}`,
    };
};

export const useScenarioPeriodListQuery = createApiQueryHook<
    IScenarioPeriodListQueryParameters,
    IScenarioPeriodListQueryResult
>(scenarioPeriodListQuery);
